import script from "./ConnexionComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./ConnexionComponent.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__